"use client"

import { useEffect, useRef } from "react"
import { usePathname } from "next/navigation"

/**
 * RouteScrollRestoration
 *
 * Scrolls to top on client-side route changes only.
 * Does NOT interfere with browser-native scroll restoration on refresh.
 * Uses pathname comparison (not a first-render flag) so it works
 * correctly under React Strict Mode's double-effect behavior.
 */
export function RouteScrollRestoration() {
  const pathname = usePathname()
  const prevPathname = useRef(pathname)

  useEffect(() => {
    if (prevPathname.current !== pathname) {
      prevPathname.current = pathname
      window.scrollTo({ top: 0, left: 0, behavior: "instant" })
    }
  }, [pathname])

  return null
}
